import Link from 'next/link'
import { Layout } from '../../components/front'
import { getProductCategories } from '../../lib'

export async function getServerSideProps() {
    const hier = await getProductCategories()

    return { props: { productCategories: hier } }
}

export default function Detail({ productCategories }) {
    return (
        <Layout>
            <div className="">
                <CategoryPage item={productCategories} />
            </div>
        </Layout>
    )
}

function CategoryPage({ item }) {
    return (
        <>
            <div className="bg-white text-center text-purple-500 inline-block py-2 px-6 ms-4 mt-2">
                <Link href="/products">
                    <a>
                        مشاهده همه محصولات{' '}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ width: 16 }}
                            className="inline"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </a>
                </Link>
            </div>
            <div className="grid grid-cols-2  md:grid-cols-3">
                {item.map((category, id) => (
                    <div key={id} className=" rounded w-full flex p-2 ">
                        <div className="flex flex-col bg-white text-center w-full m-1 mx-3">
                            <img src={`/api/${category.img_path}`} className="w-20 rounded-full mb-2 mx-auto" />
                            <Link href={category.href || ''}>
                                <a className="border-b-2 w-full block p-2 text-purple-500">{category.title}</a>
                            </Link>
                            {category.children && category.children.length !== 0 && (
                                <ul className="p-2">
                                    {category.children.map((subCategory, idx) => (
                                        <li key={idx} className="py-2">
                                            <Link href={subCategory.href || ''}>
                                                <a className="p-2">{subCategory.title}</a>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}
